module.exports = __webpack_public_path__ + "img/shiyannengli.482842aa.png";